import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import DrawerHeaderStyled from "./DrawerHeaderStyled";
import Logo from "components/logo";
import useConfig from "hooks/useConfig";
import { LAYOUT_CONST } from "types/config";
interface Props {
  open: boolean;
}

const DrawerHeader = ({ open }: Props) => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));
  const { menuOrientation } = useConfig();

  const isHorizontal =
    menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;

  // Optimized sx values
  let paddingLeftValue;
  if (isHorizontal) {
    paddingLeftValue = { xs: "24px", lg: "0" };
  } else if (open) {
    paddingLeftValue = "24px";
  } else paddingLeftValue = 0

  const drawerStyles = {
    minHeight: isHorizontal ? "unset" : "60px",
    width: isHorizontal ? { xs: "100%", lg: "424px" } : "inherit",
    paddingTop: isHorizontal ? { xs: "10px", lg: "0" } : "30px",
    paddingBottom: isHorizontal ? { xs: "18px", lg: "0" } : "8px",
    paddingLeft: paddingLeftValue,
  };

  return (
    <DrawerHeaderStyled theme={theme} open={open} sx={drawerStyles}>
      <Logo isIcon={!open} sx={{ width: open ? "auto" : 35, height: 35 }} />
    </DrawerHeaderStyled>
  );
};

export default DrawerHeader;
